(function () {
  'use strict';

  angular.module('MktzapApp.Controllers')
    .controller('MessagesPortalTemplateCreateController', messagesPortalTemplateCreateController)

  messagesPortalTemplateCreateController.inject = ['MessagesPortalTemplateService', 'NotificationService', '$location', '$stateParams', 'LangService', 'WaentService', 'SectorService', 'HsmCrudService']

  function messagesPortalTemplateCreateController (MessagesPortalTemplateService, NotificationService, $location, $stateParams, LangService, WaentService, SectorService, HsmCrudService) {
    var vm = this;
    vm.id;
    vm.sendingChannels = {};
    vm.sendingChannel = '-1';
    vm.receivingChannels = [];
    vm.receivingChannel = '-1';
    vm.subChannel = '-1';
    vm.subChannels = [];
    vm.subChannelParsed = '';
    vm.description = '';
    vm.message = '';
    vm.messageLength = '';
    vm.sectorDescription = '';
    vm.addLink = addLink;
    vm.refreshMessageLength = refreshMessageLength;
    vm.refreshSectorDescription = refreshSectorDescription;
    vm.refreshSubChannelSectorDescription = refreshSubChannelSectorDescription;
    vm.loadChannels = loadChannels;
    vm.save = save;
    vm.receivingChannelType = '';
    vm.sendingChannelType = '-1';
    vm.checkSendingType = checkSendingType;
    vm.hsmMessages = [];
    vm.hsm = {};
    vm.updateHsm = updateHsm;
    LangService
      .getPageLabels({ 'page': 'menu.messagesPortal.messagesTemplateCreate' })
      .$promise
      .then(function (data) {
        vm.labels = data.lang;
      });

    refreshMessageLength();

    if ($stateParams.id) {
      MessagesPortalTemplateService
        .find({ 'id': $stateParams.id })
        .$promise
        .then(function (messageTemplate) {
          vm.id = $stateParams.id;
          if (messageTemplate) {
            vm.id = messageTemplate._id;
            vm.description = messageTemplate.description;
            vm.message = messageTemplate.message;
            if (messageTemplate.hsm_message) {
              vm.hsmId = messageTemplate.hsm_message.id;
              vm.hsm = messageTemplate.hsm_message
            }
            if (!vm.receivingChannelType) {
              if (messageTemplate.receiving_channel) {
                vm.receivingChannelType = 'whatsapp';
                if (messageTemplate.receiving_channel.channel_class.indexOf('Waent') >= 0) {
                  vm.receivingChannelType = 'waent';
                }
              }
            }
            MessagesPortalTemplateService
              .getChannelsWaentSms()
              .$promise
              .then(function (data) {
                vm.sendingChannels = data;
                vm.sendingChannel = messageTemplate.sending_channel.channel_id.toString();
                vm.sendingChannelType = 'sms';
                if (messageTemplate.sending_channel.channel_class.indexOf('Waent') >= 0) {
                  vm.sendingChannelType = 'waent';
                }
              })
              .catch(function () {
                NotificationService.errorHandler(vm, vm.labels.errorLoadingChannel);
              });

            MessagesPortalTemplateService
              .getChannelsByChannelType({ type: vm.receivingChannelType })
              .$promise
              .then(function (data) {
                vm.receivingChannels = data.channels;
                vm.receivingChannel = messageTemplate.receiving_channel.channel_id.toString();
                refreshSectorDescription();
                if (messageTemplate.receiving_subchannel) {
                  if (messageTemplate.receiving_subchannel.sectorName) {
                    // removendo sectorName, utilizado apenas no save
                    delete messageTemplate.receiving_subchannel['sectorName'];
                  }
                  vm.subChannel = JSON.stringify(messageTemplate.receiving_subchannel);
                  refreshSubChannelSectorDescription();
                }
              })
              .catch(function () {
                NotificationService.errorHandler(vm, vm.labels.errorLoadingChannel);
              });
          }
          refreshMessageLength();
        })
        .catch(function () {
          NotificationService.errorHandler(vm, vm.labels.errorLoadingMessages);
        });
    } else {
      loadChannels();
    }

    function loadChannels (resolve) {
      vm.subChannel = '-1';
      vm.subChannels = [];
      vm.subChannelParsed = '';
      vm.sectorDescription = '';
      vm.receivingChannel = '';
      if (angular.equals(vm.sendingChannels, {})) {
        MessagesPortalTemplateService
          .getChannelsWaentSms()
          .$promise
          .then(function (data) {
            vm.sendingChannels = data;
          })
          .catch(function () {
            NotificationService.errorHandler(vm, vm.labels.errorLoadingChannel);
          });
      }

      MessagesPortalTemplateService
        .getChannelsByChannelType({ type: vm.receivingChannelType })
        .$promise
        .then(function (data) {
          vm.receivingChannels = data.channels;
          if (resolve) {
            resolve();
          }
        })
        .catch(function () {
          NotificationService.errorHandler(vm, vm.labels.errorLoadingChannel);
        });
    }

    function addLink (value) {
      var field = document.getElementById('txtMessage');
      value = '{$LINK$}';

      if (vm.messageLength - 27 < 0) {
        return;
      }

      if (field.selectionStart || field.selectionStart == '0') {
        var startPos = field.selectionStart;
        var endPos = field.selectionEnd;
        field.value = field.value.substring(0, startPos) +
                    value +
                    field.value.substring(endPos, field.value.length);

        if (field.setSelectionRange) {
          var cursorPos = startPos + (value.length);
          field.focus();
          field.setSelectionRange(cursorPos, cursorPos);
        }
      } else {
        field.value += value;
      }
      vm.message = field.value;

      refreshMessageLength();
    }

    function refreshMessageLength () {
      vm.messageLength = 160 - document.getElementById('txtMessage').value.split('{$LINK$}').join('111111111111111111111111111').length;
    }

    function refreshSectorDescription () {
      vm.subChannel = '-1';
      vm.subChannels = [];
      vm.subChannelParsed = '';
      vm.sectorDescription = '';
      let filteredChannel = getChannel(vm.receivingChannels, vm.receivingChannel);
      // se for waent, busca subcanais
      if (vm.receivingChannelType == 'waent') {
        WaentService
          .getSubChannels({ channels: vm.receivingChannels })
          .$promise
          .then(function (data) {
            if (data.length) {
              vm.subChannels = data.find(channel => channel.id == vm.receivingChannel).subChannels || [];
            }
          })
          .catch(function (err) {
          });

        HsmCrudService
          .all()
          .$promise
          .then(function (data) {
            if (data.length) {
              vm.hsmMessages = data;
            }
          })
      }

      if (filteredChannel && filteredChannel.sector) {
        vm.sectorDescription = filteredChannel.default_sector_id + ' - ' + filteredChannel.sector.name;
      } else {
        vm.sectorDescription = '';
      }
    }

    function updateHsm (hsmId) {
      vm.hsm = vm.hsmMessages.find(hsm => hsm.id == hsmId)
      vm.message = ''
      if (vm.hsm) {
        vm.message = vm.hsm.template
      }
    }

    function refreshSubChannelSectorDescription () {
      if (vm.subChannel < 0) {
        refreshSectorDescription();
        return false;
      }
      vm.subChannelParsed = JSON.parse(vm.subChannel);
      SectorService
        .loadSectorsByCompany()
        .$promise
        .then(function (data) {
          if (typeof data.sectors !== 'undefined') {
            var receivingChannel = getChannel(vm.receivingChannels, vm.receivingChannel);
            var sectors = data.sectors.filter(sector => sector.company_id == receivingChannel.company_id);
            if (sectors.length) {
              var sector = sectors.find(sector => sector.id == vm.subChannelParsed.default_sector_id);
              if (typeof sector.name !== 'undefined') {
                vm.sectorDescription = vm.subChannelParsed.default_sector_id + ' - ' + sector.name;
                vm.subChannelParsed.sectorName = sector.name;
                vm.subChannelSectorId = sector.id;
              }
            }
          }
        })
        .catch(function (error) {
        });
    }

    function checkSendingType () {
      if (vm.sendingChannelType == 'waent') {
        vm.receivingChannelType = 'waent';
        var promise = new Promise(function (resolve, reject) {
          vm.loadChannels(function () {
            resolve('successo');
          });
        })
          .then(function () {
            vm.receivingChannel = vm.sendingChannel;
            refreshSectorDescription();
          });
      }
    }

    function getChannel (channelArray, channelId) {
      if (channelId >= 0) {
        let arrayFilteredChannel = channelArray.filter(function (elem, index, array) {
          return array[index].id == channelId;
        });

        if (arrayFilteredChannel.length > 0) {
          return arrayFilteredChannel[0];
        }
      }
      return null;
    }

    function save () {
      if (vm.sendingChannel < 0) {
        NotificationService.errorHandler(null, vm.labels.errorSendingChannel);
        return;
      }

      if (vm.receivingChannel < 0) {
        NotificationService.errorHandler(null, vm.labels.errorReceivingChannel);
        return;
      }

      if (!vm.description) {
        NotificationService.errorHandler(null, vm.labels.errorDescription);
        return;
      }

      if (!vm.message) {
        NotificationService.errorHandler(null, vm.labels.errorMessage);
        return;
      }

      let arrSendingChannels = vm.sendingChannels.channelsSms;
      if (vm.sendingChannelType == 'waent') {
        arrSendingChannels = vm.sendingChannels.channelsWaent;
      }
      let sendingChannel = getChannel(arrSendingChannels, vm.sendingChannel);
      let receivingChannel = getChannel(vm.receivingChannels, vm.receivingChannel);

      if (!receivingChannel.sector) {
        NotificationService.errorHandler(null, vm.labels.errorReceivingChannelSector);
        return;
      }
      let hasSubChannel = (vm.subChannel != -1 && typeof vm.subChannelParsed !== 'undefined' && vm.subChannelParsed != '');
      var obj = {
        'id': vm.id,
        'company_id': receivingChannel.company_id,
        'user_id': '',
        'description': vm.description,
        'message': vm.message,
        'hsm_message': '',
        'url': 'https://wa.me/' + receivingChannel.phone_number,
        'sending_channel': {
          'channel_class': vm.sendingChannelType == 'waent' ? 'App\\Models\\Channels\\Waent' : 'App\\Models\\Channels\\SMS',
          'channel_id': sendingChannel.id
        },
        'receiving_channel': {
          'channel_class': vm.receivingChannelType == 'waent' ? 'App\\Models\\Channels\\Waent' : 'App\\Models\\Channels\\WhatsappWeb',
          'channel_id': receivingChannel.id,
          'sector_id': receivingChannel.sector.id
        },
        'receiving_subchannel': ''
      };

      if (vm.receivingChannelType == 'waent') {
        obj.url = 'https://wa.me/' + receivingChannel.external_id;
      }
      obj.url = obj.url.replace(/\s/g, '')

      if (vm.sendingChannelType == 'waent' && vm.hsm) {
        obj.hsm_message = vm.hsm;
      }
      if (hasSubChannel) {
        obj.receiving_subchannel = vm.subChannelParsed;
      }

      MessagesPortalTemplateService
        .save(obj)
        .$promise
        .then(function (data) {
          if (data.success) {
            NotificationService.successHandler(data, vm.labels.saveSuccess);
          } else {
            NotificationService.errorHandler(data, data.message);
          }

          $location.path(baseUrl + '/messages-portal/templates-overview');
        }).catch(function (data) {
        });
    }
  }
})();
